import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AutoApplyStatusAndDraftsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AutoApplyStatusAndDraftsQuery = { __typename?: 'Query', findReviewBeforeSubmitDrafts?: { __typename?: 'FindReviewBeforeSubmitDraftsPayload', drafts: Array<{ __typename?: 'AutoApplyDraft', applicationDraftId: string, indeedJobKey?: string | null, jobTitle: string, jobLocation: string, employerName?: string | null }> } | null, autoApplyInfo?: { __typename?: 'AutoApplyInfoPayload', autoApplyStatus?: Types.AutoApplyStatus | null, mode?: Types.AutoApplyMode | null } | null };


export const AutoApplyStatusAndDraftsDocument = gql`
    query autoApplyStatusAndDrafts {
  findReviewBeforeSubmitDrafts(input: {first: 5}) {
    drafts {
      applicationDraftId
      indeedJobKey
      jobTitle
      jobLocation
      employerName
    }
  }
  autoApplyInfo {
    autoApplyStatus
    mode
  }
}
    `;

/**
 * __useAutoApplyStatusAndDraftsQuery__
 *
 * To run a query within a React component, call `useAutoApplyStatusAndDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoApplyStatusAndDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoApplyStatusAndDraftsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutoApplyStatusAndDraftsQuery(baseOptions?: Apollo.QueryHookOptions<AutoApplyStatusAndDraftsQuery, AutoApplyStatusAndDraftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutoApplyStatusAndDraftsQuery, AutoApplyStatusAndDraftsQueryVariables>(AutoApplyStatusAndDraftsDocument, options);
      }
export function useAutoApplyStatusAndDraftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutoApplyStatusAndDraftsQuery, AutoApplyStatusAndDraftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutoApplyStatusAndDraftsQuery, AutoApplyStatusAndDraftsQueryVariables>(AutoApplyStatusAndDraftsDocument, options);
        }
export function useAutoApplyStatusAndDraftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutoApplyStatusAndDraftsQuery, AutoApplyStatusAndDraftsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutoApplyStatusAndDraftsQuery, AutoApplyStatusAndDraftsQueryVariables>(AutoApplyStatusAndDraftsDocument, options);
        }
export type AutoApplyStatusAndDraftsQueryHookResult = ReturnType<typeof useAutoApplyStatusAndDraftsQuery>;
export type AutoApplyStatusAndDraftsLazyQueryHookResult = ReturnType<typeof useAutoApplyStatusAndDraftsLazyQuery>;
export type AutoApplyStatusAndDraftsSuspenseQueryHookResult = ReturnType<typeof useAutoApplyStatusAndDraftsSuspenseQuery>;
export type AutoApplyStatusAndDraftsQueryResult = Apollo.QueryResult<AutoApplyStatusAndDraftsQuery, AutoApplyStatusAndDraftsQueryVariables>;